import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { ResponsivePie } from "@nivo/pie";
import { nivo_theme } from "./chart-utils";

/**
 * A half-donut pie chart with a total label
 * @param {Object[]} data [{id, value, color}]
 * @param {function} onClick datum -> void E.g. use datum.id
 * @param {string} label What are we counting? e.g. "Questions"
 */
export default function PieDialWithTotal({ data, onClick, totalLabel, width = "100%", height = "300px" }) {
  // filter zeros (to avoid pad-angle making a not-quite-full semi-circle)
  const filteredData = data.filter((d) => d.value > 0);
  const total = filteredData.reduce((acc, d) => acc + d.value, 0);

  return (
    <Box width={width} height={height} position="relative">
      <ResponsivePie
        data={filteredData}
        innerRadius={0.7}
        padAngle={1}
        cornerRadius={3}
        colors={(d) => d.data.color} // e.g. stage.queued in colors.js
        startAngle={-90}
        endAngle={90}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        onClick={onClick}
        theme={nivo_theme}
      />
      <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" textAlign="center">
        <Text fontSize="2xl" fontWeight="bold">
          {total}
        </Text>
        <Text fontSize="sm" color="gray.500">
          {totalLabel}
        </Text>
      </Box>
    </Box>
  );
}
